export default __webpack_public_path__ + "static/media/firebase.7840999a.svg";